// context/ThemeContext.jsx
import React, { createContext, useContext, useEffect, useState } from 'react';

const STORAGE_KEY = 'spotfli_theme';

const ThemeContext = createContext({
    theme: 'light',
    toggleTheme: () => {}
});

/* Thème initial : choix mémorisé > préférence système > clair */
const getInitialTheme = () => {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored === 'dark' || stored === 'light') return stored;
    } catch (e) {
        /* localStorage indisponible — on continue */
    }
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        return 'dark';
    }
    return 'light';
};

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState(() => {
        const initial = getInitialTheme();
        // Appliqué immédiatement pour éviter le flash de thème clair au chargement
        document.documentElement.setAttribute('data-theme', initial);
        return initial;
    });

    useEffect(() => {
        document.documentElement.setAttribute('data-theme', theme);
        // Petite classe d'animation pour la transition douce des couleurs
        document.documentElement.classList.add('theme-anim');
        const t = setTimeout(() => {
            document.documentElement.classList.remove('theme-anim');
        }, 700);
        try {
            localStorage.setItem(STORAGE_KEY, theme);
        } catch (e) {
            /* ignore */
        }
        return () => clearTimeout(t);
    }, [theme]);

    const toggleTheme = () => {
        setTheme(t => (t === 'dark' ? 'light' : 'dark'));
    };

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => useContext(ThemeContext);
